import { Box, Card, CardContent, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { StatusDot } from './StatusIcon';

interface ProjectSummaryCardsProps {
  referenceStandardReviewProjectsCount: number;
  inProgressProjectsCount: number;
  completedProjectsCount: number;
  totalProjectsCount: number;
}
export const ProjectSummaryCards = ({
  referenceStandardReviewProjectsCount,
  inProgressProjectsCount,
  completedProjectsCount,
  totalProjectsCount,
}: ProjectSummaryCardsProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', gap: theme.spacing(6), p: theme.spacing(4) }}>
      <Card
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h5">{totalProjectsCount}</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(3) }}>
            <Typography variant="subtitle1">
              {formatMessage({ id: 'annotatorProjects.summary.totalProjects.title' })}
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <Card
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h5">{referenceStandardReviewProjectsCount}</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(3) }}>
            <StatusDot color={theme.palette.warning.main} />
            <Typography variant="subtitle1">
              {formatMessage({ id: 'annotatorProjects.summary.refStdReview.title' })}
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <Card
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h5">{inProgressProjectsCount}</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(3) }}>
            <StatusDot color={theme.palette.info.main} />
            <Typography variant="subtitle1">
              {formatMessage({ id: 'annotatorProjects.summary.inProgressProjects.title' })}
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <Card
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h5">{completedProjectsCount}</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(3) }}>
            <StatusDot color={theme.palette.success.main} />
            <Typography variant="subtitle1">
              {formatMessage({ id: 'annotatorProjects.summary.completedProjects.title' })}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};
